/**
 * Format tiền
 * @param {*} value
 */
export default {
  amountFormat(value) {
    if (value != null) {
      // const currentBranch = branchContext.getCurrentBranch();
      const currentBranch = null;
      const groupSeparator = currentBranch?.GeneralGroupSeparator ?? ',';
      const decimalSeparator = currentBranch?.GeneralDecimalSeparator ?? '.';
      const decimalDigits = currentBranch?.AmountDecimalDigits ?? 2;

      let fotmatedNumber = value.numberFormat(
        decimalDigits,
        decimalSeparator,
        groupSeparator
      );

      return fotmatedNumber;
    }
  },

  inputMask(value) {
    if (value != null) {
      // const currentBranch = branchContext.getCurrentBranch();
      const currentBranch = null;
      const groupSeparator = currentBranch?.GeneralGroupSeparator ?? ',';
      const decimalSeparator = currentBranch?.GeneralDecimalSeparator ?? '.';
      const decimalDigits = currentBranch?.AmountDecimalDigits ?? 2;
      const numberFormat = {
        decimal: decimalSeparator,
        precision: decimalDigits,
      };
      if (typeof value == 'string') {
        value = unformat(value, numberFormat);
      }

      let fotmatedNumber = value.inputMaskNumberFormat(
        decimalDigits,
        decimalSeparator,
        groupSeparator
      );

      return fotmatedNumber;
    }
  },

  /**
   * hủy format
   */
  unformat(value, numberFormat) {
    let result = 0;
    if (!value) {
      return result;
    }

    if (numberFormat.decimal === '.' && !isNaN(+value)) {
      return +value;
    }
    value = '' + value;
    const negative = value.startsWith('-') ? -1 : 1;
    if (numberFormat) {
      if (value.indexOf(numberFormat.decimal) < 0) {
        value = value + numberFormat.decimal + '0000';
      }
      // Kiểm tra giá trị truyền vào có kí tự phần thập phân hay không?
      // Lấy vị trí phần thập phân
      const decimal_pos = value.indexOf(numberFormat.decimal);
      // Lần lượt lấy vị trí bên trái và bên phải phần thập phân
      const left_side = value.substring(0, decimal_pos).replace(/\D/g, '');
      let right_side = value.substring(decimal_pos + 1).replace(/\D/g, '');
      right_side = right_side.substring(0, numberFormat.precision);
      value = left_side + '.' + right_side;
      result = +value * negative;
    }
    return result;
  },
};
